// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGetCustomObjectsUserLinkedCustomObjectTypesResult = objectOf({
  items: arrayOf(
    objectOf({
      display_name: string,
      co_type_id: number,
    })
  ),
});
